import { client } from '../../../services/apiClient';
import type {
  CreatePromptAnalysisRequest,
  PromptAnalysis,
  PromptAnalysisUsageResponse,
} from '@brand24-original/llm-types';

const ENDPOINT = '/prompt-analysis';

/** Account-scoped (quota is shared by all projects) — hence no projectId in the path. */
export const getPromptAnalysisUsage = async (): Promise<PromptAnalysisUsageResponse> => {
  const { data } = await client(true, true).get<PromptAnalysisUsageResponse>(`${ENDPOINT}/usage`);
  return data;
};

export const getPromptAnalyses = async (projectId: number): Promise<PromptAnalysis[]> => {
  const { data } = await client(true, true).get<PromptAnalysis[]>(`${ENDPOINT}/${projectId}`);
  return data;
};

export const createPromptAnalysis = async (
  projectId: number,
  body: CreatePromptAnalysisRequest
): Promise<PromptAnalysis> => {
  const { data } = await client(true, true).post<PromptAnalysis>(`${ENDPOINT}/${projectId}`, body);
  return data;
};
